import React from 'react';
import styled from 'styled-components';
import colors from "../styles/colors";

interface Props {
  onClick: () => void;
  title: string;
}

const DeleteButtonStyle = styled.button`
  background-color: ${colors.red};
  border: 1px solid ${colors.red};
  border-radius: 7px;
  font-weight: bold;
  font-size: 16px;
  color: ${colors.white};
  padding: 8px 25px;
  cursor: pointer;
  outline: none;
  :hover {
    opacity: .8;
  }
`;

export default function DeleteButton(props: Props) {
  return (
    <>
      <DeleteButtonStyle type="button" onClick={props.onClick}>
        {props.title}
      </DeleteButtonStyle>
    </>

  );
};